<template>
  <div>
    <div class="mb-3">
      กรุณากรอกข้อมูลในช่องที่มีเครื่องหมาย
      <span class="red--text">*</span> ให้ครบ
    </div>

    <ValidationObserver ref="observer">
      <ValidationProvider
        name="หมายเลขอ้างอิง Ref Claim No."
        :rules="{
          required: true,
        }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            หมายเลขอ้างอิง Ref Claim No.<span class="red--text">*</span>
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                dense
                v-model="input.ref_claim_no"
                label
                outlined
                :error-messages="errors"
                :success="valid"
                :hide-details="errors.length == 0"
                placeholder="หมายเลขอ้างอิง Ref Claim No."
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
      </ValidationProvider>
      <!--   <ValidationProvider
        name="ชื่อ Name"
        :rules="{
          required: true,
        }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            ชื่อ Name <span class="red--text">*</span>
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                dense
                v-model="input.name"
                label
                outlined
                :error-messages="errors"
                :success="valid"
                :hide-details="errors.length == 0"
                placeholder="ชื่อ Name"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
      </ValidationProvider>
      <ValidationProvider
        name="นามสกุล Last Name"
        :rules="{
          required: true,
        }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            นามสกุล Last Name <span class="red--text">*</span>
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                dense
                v-model="input.surname"
                label
                outlined
                :error-messages="errors"
                :success="valid"
                :hide-details="errors.length == 0"
                placeholder="นามสกุล Last Name"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
      </ValidationProvider> -->

      <ValidationProvider
        name="อีเมล Email address"
        :rules="{ required: true, email: true }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            อีเมล Email address <span class="red--text">*</span>
          </div>

          <v-text-field
            dense
            v-model="input.email"
            label
            outlined
            :error-messages="errors"
            :success="input.email ? valid : false"
            :hide-details="errors.length == 0"
            placeholder="อีเมล Email address"
          ></v-text-field>
        </div>
      </ValidationProvider>

      <!-- <ValidationProvider
        name="เบอร์โทรศัพท์มือถือ Phone No."
        :rules="{ required: true, regex: /^[0][3-9]-[0-9]{4}-[0-9]{4}$/ }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            เบอร์โทรศัพท์มือถือ Phone No. <span class="red--text">*</span>
          </div>
          <v-text-field
            name="เบอร์โทรศัพท์มือถือ Phone No."
            :key="'phone'"
            ref="mobilephone"
            dense
            v-model="input.phone"
            label
            outlined
            v-mask="'##-####-####'"
            type="tel"
            placeholder="เบอร์โทรศัพท์มือถือ Phone No."
            :error-messages="errors"
            :success="valid"
            :hide-details="errors.length == 0"
          ></v-text-field>
        </div>
      </ValidationProvider> -->

      <div class="mt-6">
        <h4 class="mb-3">อัปโหลดไฟล์เอกสารเพิ่มเติม</h4>
        <ValidationProvider
          name="เอกสารอื่นๆ Upload Other Documents"
          :rules="{ required: true }"
          v-slot="{ errors }"
        >
          <div class="mb-4" :class="{ 'has-error': errors[0] }">
            <div class="font-weight-bold">
              อัปโหลดเอกสารอื่นๆ Upload Other Documents
              <span class="red--text">*</span>
            </div>
            <div style="min-height: 90px">
              <UploadMultipleFile
                :errors="errors"
                v-model="input.other_file"
                :maxUploadFile="4"
                >Upload Other</UploadMultipleFile
              >
            </div>
            <div class="red--text error-text" v-if="errors.length">
              <span style="font-size: 12px" class="px-2">
                กรุณาอัปโหลด {{ errors[0].replace("กรุณากรอก ", "") }}
              </span>
            </div>
          </div>
        </ValidationProvider>
      </div>

      <div class="pt-2">
        <v-layout>
          <v-flex>
            <v-checkbox
              v-model="acceptConsent"
              class="mx-2 mt-0"
              color="primary"
            ></v-checkbox>
          </v-flex>
          <v-flex style="padding-right: 48px">
            <div class="mb-4">
              ข้าพเจ้ายืนยันว่าข้อมูลข้างต้นเป็นข้อมูลที่ถูกต้องแท้จริงของข้าพเจ้า
              พร้อมรับทราบว่าเจนเนอราลี่ ทำการประมวลข้อมูล ส่วนบุคคล
              รวมถึงข้อมูลสุขภาพตาม นโยบายส่วนบุคคล
              และตกลงตามเงื่อนไขการใช้บริการเรียกร้องค่าสินไหมผ่าน
              ช่องทางออนไลน์
            </div>
            <div>
              I hereby confirmed that my personal data above is correct and true
              and acknowledged that Generali shall process my personal data and
              health data in accordance with Generali's Privacy Policy. I hereby
              agreed to the terms and conditions with respect to claim services
              via online channel
            </div>
          </v-flex>
        </v-layout>
      </div>

      <div class="text-center mt-10">
        <v-btn
          @click="handleSubmit"
          color="primary"
          depressed
          block
          large
          :loading="loading"
          :disabled="!acceptConsent"
        >
          <span style="font-size: 18px">ส่งเอกสาร / SUBMIT</span>
        </v-btn>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mask } from "vue-the-mask";
import UploadMultipleFile from "@/components/UploadMultipleFile.vue";

export default {
  props: ["resetForm", "loading"],
  components: {
    ValidationProvider,
    ValidationObserver,
    UploadMultipleFile,
  },
  directives: {
    mask,
  },
  data() {
    return {
      // loading: false,
      input: {
        ref_claim_no: "",
        // name: "",
        // surname: "",
        email: "",
        // phone: "",
        // receipt_file: "",
        // medical_citificate_file: "",
        // book_bank_file: "",
        other_file: [],
        // national_id_card_photo: "",
      },
      acceptConsent: false,
    };
  },
  watch: {
    resetForm() {
      this.handleResetForm();
    },
  },
  methods: {
    async handleSubmit() {
      const vm = this;
      try {
        const isValid = await vm.$refs.observer.validate();

        if (isValid) {
          vm.$emit("onSubmit", { form_type: "additional", ...vm.input });
        } else {
          const el = document.querySelector(".has-error:first-of-type");
          el.scrollIntoView({ block: "start", behavior: "smooth" });
          return false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    handleResetForm() {
      this.input = {
        ref_claim_no: "",
        // name: "",
        // surname: "",
        email: "",
        // phone: "",
        // receipt_file: "",
        // medical_citificate_file: "",
        // book_bank_file: "",
        other_file: [],
        // national_id_card_photo: "",
      };
      this.$refs.observer.reset();
    },
  },
};
</script>

<style lang="scss" scoped></style>
